import api from "./api";

// Resumable chunked upload. Splits the file into small chunks that each stay under
// any reverse-proxy body-size limit, then completes server-side.
// meta: { kind: "drive"|"files"|"bank", category, ref_id, ref_label, doc_type, date_hint, context }
export async function chunkedUpload(file, meta = {}, onProgress) {
  const { data: init } = await api.post("/uploads/init", {
    kind: meta.kind || "files",
    filename: file.name || "upload.bin",
    content_type: file.type || "application/octet-stream",
    total_size: file.size || 0,
    category: meta.category || "",
    ref_id: meta.ref_id || "",
    ref_label: meta.ref_label || "",
    doc_type: meta.doc_type || "",
    date_hint: meta.date_hint || "",
    context: meta.context || "",
    force: meta.force || false,
  });

  const uploadId = init.upload_id;
  const chunkSize = init.chunk_size || 512 * 1024;
  const total = Math.max(1, Math.ceil((file.size || 0) / chunkSize));

  for (let i = 0; i < total; i++) {
    const blob = file.slice(i * chunkSize, (i + 1) * chunkSize);
    await api.post(`/uploads/${uploadId}/chunk`, blob, {
      headers: { "Content-Type": "application/octet-stream" },
    });
    onProgress?.(Math.round(((i + 1) / total) * 100));
  }

  const { data: doc } = await api.post(`/uploads/${uploadId}/complete`, {});
  return doc;
}

export const MAX_UPLOAD_MB = 100;
